module.exports = __webpack_public_path__ + "img/cskj.f61ebc8b.png";